import type { DataAttachmentType } from '@elara/domain/models/schemas/attachment-schemas';

import type { IconName } from '@elara/client-core/ui-contracts/icon-name';

/**
 * Route path constants.
 *
 * The canonical `ROUTES` vocabulary now lives in the DOM-free `#states/routing-contract.js` (shared
 * with `@elara/mobile`, ELARA-704). Re-exported here so the web call sites importing from
 * `#constants` are unchanged.
 */
export { ROUTES, tripPanelPath } from '#states/routing-contract.js';
export type { TripPanelType } from '#states/routing-contract.js';

/**
 * Icon constants for consistent icon usage across the application
 */

export const TRIP_PANEL_ICONS = {
  chat: 'chat_bubble',
  shortlist: 'favorite',
  itinerary: 'calendar_today',
  bookings: 'local_activity',
  tasks: 'check_box',
} as const;

export type TripPanelIcon = keyof typeof TRIP_PANEL_ICONS;

export const DATA_ATTACHMENT_ICONS: Record<DataAttachmentType, IconName> = {
  destination: 'place',
  hotel: 'hotel',
  place: 'place',
} as const;

// Default to 4 available rooms unless Sabre API returns availability.
export const DEFAULT_AVAILABLE_ROOM_QUANTITY = 4;

export const MIN_PASSWORD_LENGTH = 8;
